import { isRecordEmpty } from 'hx-util';
import { useEffect, useState } from 'react';
export var useTrackSubscription = function (_a) {
    var participant = _a.participant, voiceOnly = _a.voiceOnly;
    var _b = useState({}), videoTrack = _b[0], setVideoTrack = _b[1];
    var _c = useState({}), audioTrack = _c[0], setAudioTrack = _c[1];
    useEffect(function () {
        if (!participant || isRecordEmpty(participant))
            return;
        var trackSubscribed = function (track) {
            if (track.kind === 'video') {
                setVideoTrack(track);
            }
            else if (track.kind === 'audio') {
                setAudioTrack(track);
            }
        };
        participant.tracks.forEach(function (publication) {
            if (voiceOnly && publication.track.kind === 'video')
                return;
            if (!publication.track)
                return;
            trackSubscribed(publication.track);
        });
        participant.on('trackSubscribed', trackSubscribed);
        var trackUnsubscribed = function (track) {
            if (track.kind === 'video') {
                setVideoTrack({});
            }
            else if (track.kind === 'audio') {
                setAudioTrack({});
            }
        };
        participant.on('trackUnsubscribed', trackUnsubscribed);
        return function () {
            participant.off('trackSubscribed', trackSubscribed);
            participant.off('trackUnsubscribed', trackUnsubscribed);
        };
    }, [participant]);
    return { audioTrack: audioTrack, videoTrack: videoTrack };
};
